import { render, staticRenderFns } from "./unit-information.vue?vue&type=template&id=a4046314"
import script from "./unit-information.ts?vue&type=script&lang=js&external"
export * from "./unit-information.ts?vue&type=script&lang=js&external"
import style0 from "./unit-information.vue?vue&type=style&index=0&id=a4046314&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4046314')) {
      api.createRecord('a4046314', component.options)
    } else {
      api.reload('a4046314', component.options)
    }
    module.hot.accept("./unit-information.vue?vue&type=template&id=a4046314", function () {
      api.rerender('a4046314', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/operational-data/op-data-entry-details/unit-information/unit-information.vue"
export default component.exports